module.exports = __webpack_public_path__ + "static/media/POS_03_C.23202512.png";